function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import supercluster from 'points-cluster';
import defaultPropTypes from '../utils/prop-types';
import FilterList from './filter-list';
import Location from '../utils/model';
import { UserLocationMarker, SearchLocationMarker, GoogleClusterMarker, GoogleMapMarker } from './google-map-markers';
var GoogleMap = /*#__PURE__*/function (_React$Component) {
  function GoogleMap(props) {
    var _this;
    _classCallCheck(this, GoogleMap);
    _this = _callSuper(this, GoogleMap, [props]);
    _this.mapIsReset = false;
    _this.isNewSelectedLocation = false;
    _this.handleMapChange = _this.handleMapChange.bind(_this);
    _this.handleClusterClick = _this.handleClusterClick.bind(_this);
    _this.handleLocationMarkerViewClick = _this.handleLocationMarkerViewClick.bind(_this);
    _this.options = {
      styles: _this.getStylesFromSettings(),
      fullscreenControl: false,
      clickableIcons: false
    };
    _this.searchLocation = props.searchLocation;
    _this.userLocation = props.userLocation;
    _this.selectedLocation = props.selectedLocation;
    _this.state = {
      center: {
        lat: props.searchLocation.lat,
        lng: props.searchLocation.lng
      },
      zoom: props.settings.ZoomLevel
    };
    return _this;
  }
  _inherits(GoogleMap, _React$Component);
  return _createClass(GoogleMap, [{
    key: "getStylesFromSettings",
    value: function getStylesFromSettings() {
      try {
        var cleanedString = this.props.settings.MapConfiguration.replace(/\\r/g, '').replace(/\\t/g, '').replace(/\\n/g, '').replace(/\\/g, '');
        var mapConfiguration = JSON.parse(cleanedString);
        return mapConfiguration.googlemap;
      } catch (e) {
        console.error(e);
      }
      return {};
    }
  }, {
    key: "getClusters",
    value: function getClusters(locations, center, zoom, bounds) {
      if (!this.props.useClustering) {
        return locations.map(function (location) {
          return {
            lat: location.lat,
            lng: location.lng,
            numPoints: 1,
            id: "1_".concat(location.UniqueId),
            points: [location]
          };
        });
      }
      bounds.ne.lng = 180;
      bounds.nw.lng = -180;
      bounds.se.lng = 180;
      bounds.sw.lng = -180;
      var clusters = supercluster(locations, {
        minZoom: this.props.settings.MinZoom,
        maxZoom: this.props.settings.MaxZoomLevel,
        radius: this.props.settings.ClusterRadius
      });
      var modClusters = clusters({
        bounds: bounds,
        zoom: zoom
      });
      return modClusters.map(function (_ref) {
        var wx = _ref.wx,
          wy = _ref.wy,
          numPoints = _ref.numPoints,
          points = _ref.points;
        return {
          lat: wy,
          lng: wx,
          numPoints: numPoints,
          id: "".concat(numPoints, "_").concat(points[0].UniqueId),
          points: points
        };
      });
    }
  }, {
    key: "handleMapChange",
    value: function handleMapChange(_ref2) {
      var center = _ref2.center,
        zoom = _ref2.zoom,
        bounds = _ref2.bounds;
      this.props.onMapChange({
        center: center,
        zoom: zoom,
        bounds: bounds
      });
      this.setState({
        center: center,
        zoom: zoom,
        bounds: bounds
      });
    }
  }, {
    key: "handleClusterClick",
    value: function handleClusterClick(item, currentZoom) {
      if (currentZoom < this.props.settings.MaxZoomLevel) {
        var zoom = Math.min(this.props.settings.MaxZoomLevel, currentZoom + 2);
        var center = {
          lat: item.lat,
          lng: item.lng
        };
        this.setState({
          zoom: zoom,
          center: center
        });
      }
    }
  }, {
    key: "handleLocationMarkerViewClick",
    value: function handleLocationMarkerViewClick(locationObj) {
      var _this2 = this;
      this.props.onCloseLocation();
      setTimeout(function () {
        _this2.props.onSelectLocation(locationObj);
      }, 0);
      window.DGS.Event.getInstance().trigger('trackLocationsHighlightFromMap', locationObj.Name, locationObj.PostalCode);
    }
  }, {
    key: "findSelectedLocationInClusters",
    value: function findSelectedLocationInClusters(clusters, selectedLocation) {
      var selectedClusterLocation = null;
      clusters.forEach(function (cluster) {
        cluster.points.forEach(function (clusterPoint) {
          if (clusterPoint.UniqueId === selectedLocation.UniqueId) {
            selectedClusterLocation = cluster;
          }
        });
      });
      return selectedClusterLocation;
    }
  }, {
    key: "resetMapToLocation",
    value: function resetMapToLocation(location) {
      var center = {
        lat: location.lat,
        lng: location.lng
      };
      var zoom = this.props.settings.ZoomLevel;
      var bounds = null;
      this.mapIsReset = true;
      return {
        center: center,
        zoom: zoom,
        bounds: bounds
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$state = this.state,
        center = _this$state.center,
        zoom = _this$state.zoom,
        bounds = _this$state.bounds;
      if (this.searchLocation !== this.props.searchLocation) {
        this.searchLocation = this.props.searchLocation;
        var _this$resetMapToLocat = this.resetMapToLocation(this.props.searchLocation);
        center = _this$resetMapToLocat.center;
        zoom = _this$resetMapToLocat.zoom;
        bounds = _this$resetMapToLocat.bounds;
      }
      if (this.userLocation !== this.props.userLocation) {
        this.userLocation = this.props.userLocation;
        var _this$resetMapToLocat2 = this.resetMapToLocation(this.props.userLocation);
        center = _this$resetMapToLocat2.center;
        zoom = _this$resetMapToLocat2.zoom;
        bounds = _this$resetMapToLocat2.bounds;
      }
      if (this.selectedLocation !== this.props.selectedLocation) {
        this.selectedLocation = this.props.selectedLocation;
        this.isNewSelectedLocation = true;
      }

      // CLUSTERING
      var clusters = bounds ? this.getClusters(this.props.locations, center, zoom, bounds) : [];

      // Handle if a new locations has just been clicked
      // Make sure the selected locations is visible on the map, otherwise trigger a search to
      // the selected locations latitude and longitude.
      if (clusters.length && this.isNewSelectedLocation && !this.props.selectedLocation.isDefault()) {
        var selectedLocationCluster = this.findSelectedLocationInClusters(clusters, this.props.selectedLocation);
        if (selectedLocationCluster === null) {
          // Selected location is no visible on map, trigger a new search based on the selected location lat/lng
          setTimeout(function () {
            _this3.props.onSearchLocation(_this3.props.selectedLocation);
          }, 0); // trigger search after render has finished to not create infinite loop
        }
        this.isNewSelectedLocation = false;
      }

      // Handle if the map has been reset either by search or new user location
      // Make sure that a minimum number of locations are shown, otherwise zoom out by one.
      if (bounds && this.mapIsReset) {
        if (clusters.length < this.props.settings.MinLocationsOnLoad && zoom > 1) {
          zoom -= 1;
        } else {
          this.mapIsReset = false;
        }
      }
      var UserLocationMarkerView = this.props.userLocationMarker;
      var ClusterMarkerView = this.props.clusterMarker;
      var LocationMarkerView = this.props.locationMarker;
      var SearchMarkerView = this.props.searchMarker;
      return /*#__PURE__*/React.createElement("div", {
        className: "locations-map ".concat(this.props.layoutType)
      }, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, this.props.header), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement(GoogleMapReact, {
        bootstrapURLKeys: {
          key: this.props.settings.ApiKey
        },
        zoom: zoom,
        center: center,
        options: this.options,
        onChange: this.handleMapChange
      }, /*#__PURE__*/React.createElement(UserLocationMarkerView, _extends({}, this.props.userLocation, {
        lat: this.props.userLocation.lat,
        lng: this.props.userLocation.lng
      })), /*#__PURE__*/React.createElement(SearchMarkerView, _extends({}, this.props.searchLocation, {
        lat: this.props.searchLocation.lat,
        lng: this.props.searchLocation.lng
      })), clusters.map(function (item) {
        if (item.numPoints === 1) {
          return /*#__PURE__*/React.createElement(LocationMarkerView, {
            lat: item.lat,
            lng: item.lng,
            name: item.points[0].Name,
            key: item.id,
            location: Location.fromObject(item.points[0]),
            onClick: function onClick() {
              return _this3.handleLocationMarkerViewClick(item.points[0]);
            },
            onTempSelectLocation: _this3.props.onTempSelectLocation,
            selectedClass: item.points[0].UniqueId === _this3.props.selectedLocation.UniqueId || item.points[0].UniqueId === _this3.props.tempSelectedLocation.UniqueId ? 'selected' : ''
          });
        }
        return /*#__PURE__*/React.createElement(ClusterMarkerView, {
          key: item.id,
          lat: item.lat,
          lng: item.lng,
          points: item.points,
          onClick: function onClick() {
            return _this3.handleClusterClick(item, zoom);
          }
        });
      }))), /*#__PURE__*/React.createElement(FilterList, this.props), /*#__PURE__*/React.createElement("div", {
        className: "footer"
      }, this.props.footer));
    }
  }]);
}(React.Component);
export default GoogleMap;
GoogleMap.propTypes = {
  settings: defaultPropTypes.settings,
  locations: defaultPropTypes.locations,
  selectedLocation: defaultPropTypes.location,
  tempSelectedLocation: defaultPropTypes.location,
  openLocation: defaultPropTypes.location,
  onSelectLocation: defaultPropTypes.func,
  onCloseLocation: defaultPropTypes.func,
  onSearchLocation: defaultPropTypes.func,
  onTempSelectLocation: defaultPropTypes.func,
  header: defaultPropTypes.components,
  footer: defaultPropTypes.components,
  layoutType: defaultPropTypes.layoutType,
  searchLocation: defaultPropTypes.location,
  userLocation: defaultPropTypes.location,
  zoom: PropTypes.number,
  userLocationMarker: PropTypes.func,
  clusterMarker: PropTypes.func,
  locationMarker: PropTypes.func,
  searchMarker: PropTypes.func,
  onMapChange: PropTypes.func,
  useClustering: PropTypes.bool
};
GoogleMap.defaultProps = {
  settings: defaultPropTypes.defaultSettings,
  locations: defaultPropTypes.defaultLocations,
  selectedLocation: defaultPropTypes.defaultLocation(),
  tempSelectedLocation: defaultPropTypes.defaultLocation(),
  openLocation: defaultPropTypes.defaultLocation(),
  onSelectLocation: defaultPropTypes.defaultOnSelectLocation,
  onCloseLocation: defaultPropTypes.defaultOnCloseLocation,
  onSearchLocation: defaultPropTypes.defaultOnSearchLocation,
  onTempSelectLocation: defaultPropTypes.defFunc,
  header: defaultPropTypes.defaultComponents(),
  footer: defaultPropTypes.defaultComponents(),
  searchLocation: defaultPropTypes.defaultSearchLocation,
  userLocation: defaultPropTypes.defaultLocation(),
  zoom: 8,
  layoutType: defaultPropTypes.defaultLayoutType,
  userLocationMarker: UserLocationMarker,
  clusterMarker: GoogleClusterMarker,
  locationMarker: GoogleMapMarker,
  searchMarker: SearchLocationMarker,
  onMapChange: function onMapChange() {},
  useClustering: true
};